export enum FilterType {
    Ranking = 0,
    Highlights = 1,
    Details = 2
}